<template>
    <ion-header class="pageHeader">
        <ion-toolbar>
            <ion-img src="/assets/images/mh_logo.png" style="height: 30px;" v-if="systemVersion == 'pl'"></ion-img>
            <ion-img src="/assets/images/dh_logo.png" style="height: 30px;" v-else></ion-img>
            <ion-buttons slot="start">
                <ion-menu-button></ion-menu-button>
            </ion-buttons>
            <ion-buttons slot="end" v-if="isLoggedIn">
                <ion-button fill="clear" @click="showFeedback('open')" class="feedbackIcon" :aria-label="$t('feedback.title')">
                    <ion-icon :icon="feedbackIcon" slot="icon-only"></ion-icon>
                </ion-button>
                <ion-button fill="clear" v-if="aiChatEnabled" @click="showAiAssistant('open')" @touchstart.prevent="showAiAssistant('open')" @touchend.prevent="showAiAssistant('open')" class="aiIcon">
                    <ion-img :src="systemVersion == 'pl' ? mhAiLogo : dhAiLogo" slot="icon-only" class="dhAiLogo"></ion-img>
                </ion-button>
            </ion-buttons>
        </ion-toolbar>
    </ion-header>
</template>

<script>
import {IonHeader, IonToolbar, IonImg, IonButtons, IonMenuButton, IonButton, IonIcon} from '@ionic/vue';
import {notificationsOutline} from 'ionicons/icons';
import feedbackIcon from '../../assets/icons/feedback.svg';
import dhAiLogo from '../../assets/icons/DunaGPT_logo.svg';
import {getSystemVersion, aiChatEnabled} from '../../js/functions.js';
import {userIsLoggedIn} from "@/js/users";
import mhAiLogo from "../../assets/icons/MetroGPT_logo.svg";

export default {
    props: ['pageTitle', 'pageDefaultBackLink', 'hideHeader'],
    components: {IonButton, IonIcon, IonHeader, IonToolbar, IonImg, IonButtons, IonMenuButton},
    data() {
        return {
            haveNewNotify: true,
            isLoggedIn: userIsLoggedIn(),
            systemVersion: getSystemVersion(),
            aiChatEnabled: aiChatEnabled(),

            //ICONS
            notificationsOutline,
            feedbackIcon,
            dhAiLogo,
            mhAiLogo,
            //ICONS
        }
    },
    methods: {
        showAiAssistant(mode = null) {
            this.$emit('show-ai-assistant', mode);
        },
        showFeedback(mode = null) {
            this.$emit('show-feedback', mode);
        }
    }
}
</script>
<style scoped>
.aiIcon {
    min-width: 44px;
    min-height: 44px;
}
.feedbackIcon {
    min-width: 44px;
    min-height: 44px;
    font-size: 22px;
}
</style>